module.exports = __webpack_public_path__ + "img/flash-illus.8ff9ea85.png";